export const plusSignSVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5L9 13M13 9L5 9" stroke="black" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
